export const COLORS = {
    red: "#A51E1E",
    grey: "#747474"
}